import React, { useEffect, useRef, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';

import useWizardReportDataContext from '../../../../../contexts/useWizardReportData.context';
import { IOption } from '../../../../../../../../shared/contracts/IReportDataOptions';
import useWizardReportPivotService from '../wizard-report-pivot.service';


/**
 * @author Pradeep R <pradeep.rajendran@rldatix.com>
 * @createdOn Jan/05/2025
 */
export default function WizardPivotParentFunctionComponent({ }: {}) {

    const { groupByOptions, pivotData, setPivotData } = useWizardReportDataContext();
    const { getGroupByOptionsByDataType } = useWizardReportPivotService();
    const [inputValue, setInputValue] = useState('');
    const [errorMsg, setErrorMsg] = useState<string | null>();
    const inputRef = useRef<HTMLDivElement | null>(null);

    const [options, setOptions] = useState<IOption[]>([]);

    useEffect(() => {
        setOptions(getGroupByOptionsByDataType(pivotData?.parentColumn?.columnDataType));
    }, [pivotData?.parentColumn?.columnDataType, groupByOptions]);

    const handleSelectionChange = (e: any, newValue: IOption | null) => {
        setPivotData((prev) => ({
            ...prev,
            parentGroupByFunction: newValue
        }))
    }

    // useEffect(() => {
    //     if (inputRef && inputRef.current) {
    //         inputRef.current.focus();
    //     }
    // }, [inputRef]);


    // ---
    return (<Autocomplete
        size='small'
        // sx={{ width: 412 }}
        value={pivotData ? pivotData.parentGroupByFunction : null}
        onChange={handleSelectionChange}
        inputValue={inputValue}
        onInputChange={(e, newInputValue) => setInputValue(newInputValue)}
        options={options}
        getOptionLabel={(option) => option.optionName ?? option.optionValue}
        renderInput={(params) =>
            <TextField
                {...params}
                inputRef={inputRef}
                label='Using Function'
                placeholder='Select or Search...'
                error={!!errorMsg} // Show error only if there is an error message
                helperText={errorMsg ?? undefined} // Show helper text only if there is an error
            />}
        renderGroup={(params) => (
            <li key={params.key}>
                <ul style={{ padding: 0 }}>{params.children}</ul>
            </li>
        )}
    />);
}